'use client';

import type { EventNumber, Participant, ParticipantPlayType } from '@svenskaspelab/poolbetting/schema/sport';
import { CouponEventParticipants } from '@svenskaspelab/poolbetting/ui/Coupon';
import { useSearchParams } from 'next/navigation';
import type { ReactNode } from 'react';

type CouponEventParticipantsContainerProps = {
  participants?: (Participant | undefined)[];
  eventDescription: string;
  participantType?: ParticipantPlayType;
  eventNumber: EventNumber;
};

/**
 * Container for coupon event participants.
 *
 * @param root0 props
 * @param root0.eventDescription the description of the event to be displayed
 * @param root0.participantType the type of the participants to be displayed
 * @param root0.participants the participants for the event
 * @param root0.eventNumber the number of the event to be displayed, used to see if event is selected
 * @returns CouponEventParticipants component
 */
export function CouponEventParticipantsContainer({
  eventDescription,
  participantType,
  participants,
  eventNumber,
}: CouponEventParticipantsContainerProps): ReactNode {
  const searchParams = useSearchParams();
  const eventNumberParam = searchParams.get('event');
  const selectedEventNumber = eventNumberParam ? Number.parseInt(eventNumberParam, 10) : 1;
  return (
    // Fixed 20px rows keep the two participant names inside 40px, aligned with the outcome buttons
    // column. `min-h-10` instead of `h-10` lets the head-to-head question ("Vem gör flest mål?")
    // flow onto its own row below the names instead of overflowing the row.
    <CouponEventParticipants
      className={`min-h-10 auto-rows-[20px] content-center gap-y-0 text-base/5 font-medium ${selectedEventNumber === eventNumber ? 'lg:text-primary-variant-fg' : 'text-layer-fg'}`}
      participants={participants}
      eventDescription={eventDescription}
      participantType={participantType}
    />
  );
}
